import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import dotProp from 'dot-prop';

import * as ResourceApi from "api/resources";
import {createResourceAction, deletedResourceAction} from "resources/actions";
import {startDeleteAction} from "pages/DeleteConfirmation/actions";
import SpotTheDifferencePicker from "components/forms/CustomFields/SpotTheDifferencePicker";
import {extractResourceIdsWithPath} from "utils/DBUtils";

const mapStateToProps = (state, ownProps) => {
  let proxy = ownProps.formProxy;
  let baseResource = state.resources.resources[proxy.currentBaseResource.id];
  let resource = dotProp.get(baseResource, proxy.resourcePath.join('.'));

  return {
      originalImageId: resource.image1Id,
      differencesImageId: resource.image2Id,
      differences: resource.differences,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
    addDifference: (event) => {
      var classCheck = (event.target.className === "image-difference"); //<- Make sure we're clicking the actual image and not taking into count the difference icons.
      if (classCheck) {
      //Image Dimensions
      var imageDimensions = [event.target.getBoundingClientRect().width,event.target.getBoundingClientRect().height]; //<- Dimensions of the image depending on the width of the screen (responsiveness taken into consideration)
      var frontEndDimensions = [300,200]; //<- Dimensions we take into consideration on b2c.

      //Mouse Position relative to the Image
      //NOTE from Rejon: I subtract by 16 because it seems to be giving me a more accurate coordinates of the mouse position on screen.
      var x = event.clientX-16-event.target.getBoundingClientRect().left;
      var y =  event.clientY-16-event.target.getBoundingClientRect().top;

      //Convert mouse coordinates to a percentage
      var xPercent = x/imageDimensions[0];
      var yPercent = y/imageDimensions[1];

      //Turn mouse coordinate percentages into a x/y position in relevance to our b2c image size.
      var xx = frontEndDimensions[0]*xPercent;
      var yy = frontEndDimensions[1]*yPercent;

      dispatch( createResourceAction( ResourceApi.Types.SpotTheDifferenceDifference,
                                      { top: yy,
                                        left: xx},
                                      ownProps.formProxy.currentBaseResource,
                                      extractResourceIdsWithPath(
                                        ownProps.formProxy.baseResource["MASTER"],
                                        ownProps.formProxy.currentBaseResource,
                                        ownProps.formProxy.resourcePath
                                      ),
                                      ownProps.formProxy.resourcePath,
                                      ownProps.formProxy.fieldPath.concat('differences')) )
      }
    },

    removeDifference: (difference,differenceIndex) => {
      var resourcePath = ownProps.formProxy.resourcePath.slice();
      resourcePath.push('differences.' + differenceIndex);
      var extractedResourceId = extractResourceIdsWithPath(
        ownProps.formProxy.baseResource["MASTER"],
        ownProps.formProxy.currentBaseResource,
        resourcePath
      );
      dispatch(startDeleteAction(
        difference,
        difference.resourceId,
        extractedResourceId,
        {},
        [
          deletedResourceAction(difference,
                                ownProps.formProxy.currentBaseResource,
                                extractedResourceId,
                                resourcePath,
                                resourcePath,
                                {})
        ]))
    }
  };
};

const SpotTheDifferencePickerConnected = connect(mapStateToProps, mapDispatchToProps);

const SpotTheDifferencePickerContainer = compose(
  SpotTheDifferencePickerConnected
)(SpotTheDifferencePicker);

export default SpotTheDifferencePickerContainer;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/SpotTheDifferencePickerContainer.jsx